// eslint-disable-next-line unicorn/prevent-abbreviations
export function attrBoolValue(s?: boolean | '' | null): boolean {
	return s === '' || !!s;
}
